<!--Table-->
<div class="BlockHeader">
	<h4 style="text-align: center; margin: 0px">Current Block Lists</h4>
</div>
<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstBlockList"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedStationBlockAlert"
		dataKey="StationBlockAlertID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<!--
            <tr>
				<th>
					<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="AddedByDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAddedByDesc
								[ngModel]="value"
								[options]="lstAddedByDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="DateDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter type="text" field="TimeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>
            -->

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="Message">Message<p-sortIcon field="Message"></p-sortIcon></th>
				<th pSortableColumn="AddedByDesc">Added By<p-sortIcon field="AddedByDesc"></p-sortIcon></th>
				<th pSortableColumn="DateDesc">Date Range<p-sortIcon field="DateDesc"></p-sortIcon></th>
				<th pSortableColumn="TimeDesc">Time Range<p-sortIcon field="TimeDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-StationBlockAlert>
			<tr [pSelectableRow]="StationBlockAlert">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ StationBlockAlert[col.field] }}
				</td>
				<td
					style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
					[style.color]="StationBlockAlert.Active == true ? 'Black' : 'Red'"
				>
					{{ StationBlockAlert.ActiveDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
